import { render, staticRenderFns } from "./MobilePlatform.vue?vue&type=template&id=9cbfcbf6&scoped=true&"
import script from "./MobilePlatform.vue?vue&type=script&lang=js&"
export * from "./MobilePlatform.vue?vue&type=script&lang=js&"
import style0 from "./MobilePlatform.vue?vue&type=style&index=0&id=9cbfcbf6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbfcbf6",
  null
  
)

export default component.exports